//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import aspectRatio from '~/constants/aspectRatio'
import { resolveUrlParams } from '~/helpers/url'

let uid = 0

export default {
  name: 'DynamicImage',
  props: {
    image: {
      type: Object,
      required: true
    },

    rounded: {
      type: Boolean,
      default: true
    },

    aspectRatio: {
      type: String,
      default: 'auto',
      validator: value => aspectRatio.includes(value)
    },

    transformWidths: {
      type: Array,
      default: () => [400, 800, 1200, 1600, 2000, 3000]
    },

    sizes: {
      type: Array,
      default: () => [
        { width: 350 },
        { minWidth: 500, width: 700 },
        { minWidth: 700, width: 1000 },
        { minWidth: 1000, width: 1400 },
        { minWidth: 1400, width: 2000 },
        { minWidth: 2000, width: 3000 }
      ]
    },

    lazyLoad: {
      type: Boolean,
      default: true
    },

    noFade: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      uid: `dynamicImage-${uid}`,
      hasImageLoaded: false
    }
  },

  computed: {
    crops () {
      const params = {
        auto: 'format,compress',
        fit: 'crop'
      }

      if (this.aspectRatio !== 'auto') params.ar = this.aspectRatio

      if (this.image.focalPoint && this.image.focalPoint.x && this.image.focalPoint.y) {
        const { x, y } = this.image.focalPoint
        params['fp-x'] = x
        params['fp-y'] = y
      }

      return this.transformWidths.map(width => ({
        src: resolveUrlParams(this.image.src, { ...params, w: width }),
        width
      }))
    },

    isBackgroundImage () {
      return !!this.$slots.default
    },

    srcset () {
      return this.crops.map(crop => `${crop.src} ${crop.width}w`).join(', ')
    },

    srcSizes () {
      return this.sizes.map(size =>
        size.minWidth ? `(min-width: ${size.minWidth}px) ${size.width}w` : `${size.width}w`
      ).join(', ')
    },

    baseSrc () {
      return this.crops[0].src
    },

    baseWidth () {
      return this.crops[0].width
    },

    baseHeight () {
      if (!this.actualAspectRatio) return false

      const parts = this.actualAspectRatio.split('/').map(i => parseInt(i))
      return (this.baseWidth / (parts[0] / parts[1])).toFixed(0)
    },

    actualAspectRatio () {
      if (!this.image.width || !this.image.height) return false

      return this.aspectRatio === 'auto'
        ? `${this.image.width}/${this.image.height}`
        : this.aspectRatio.replace(':', '/')
    },

    getAspectRatio () {
      if (!this.actualAspectRatio) return false

      return `aspect-ratio: ${this.actualAspectRatio};`
    },

    getFocalPoint () {
      if (!this.image.focalPoint) return

      const xPoint = `${this.image.focalPoint.x * 100}%`
      const yPoint = `${this.image.focalPoint.y * 100}%`

      return `object-position: ${xPoint} ${yPoint};`
    },

    styles () {
      return `${this.getAspectRatio} ${this.getFocalPoint}`
    },

    bgStyles () {
      const parts = this.actualAspectRatio.split('/')
      const bgPadding = parseInt(parts[1]) / parseInt(parts[0]) * 100
      return this.sizes.map((size) => {
        const firstMatch = this.crops.find(crop => crop.width >= size.width)

        if (!size.minWidth) {
          return `
          #${this.uid} {
            padding-bottom: ${bgPadding}%;
            background-image: url(${firstMatch.src});
          }
          `
        }

        return `
          @media(min-width: ${size.minWidth}px) {
            #${this.uid} {
              background-image: url(${firstMatch.src});
            }
          }`
      }).join(' ')
    },

    classes () {
      return {
        'DynamicImage--rounded': this.rounded,
        'is-visible': this.hasImageLoaded
      }
    }
  },

  beforeCreate () {
    uid += 1
  },

  methods: {
    showImage () {
      this.hasImageLoaded = true
    }
  }
}
